<template>
  <div class="Mall">
    <header
      :style="{
        borderBottom: ['Cart', 'RegularPurchaseList'].includes(route)
          ? ''
          : '2px solid #f24f18'
      }"
    >
      <div class="header">
        <div class="w-full">
          <div class="left">
            <span>您好，欢迎{{ clientName }}来到科普特 </span>
            <span @click="logout" v-if="!clientToken">请登录</span>
          </div>
          <div class="right">
            <span @click="navTo('/mall/personal/myAddress')">个人中心</span>
            <span @click="navTo('/mall/personal/myOrder')">我的订单</span>
            <!-- <span>我的收藏</span> -->
            <span @click="navTo('/mall/cart')">
              <img src="../../assets/img/home/gwc.svg" alt="" /> 购物车
            </span>
            <!-- <el-popover width="200" trigger="click">
              <img
                src="../../assets/img/code.png"
                alt=""
                style="width: 176px"
              />
              <span slot="reference">
                <img src="../../assets/img/home/sjd.svg" alt="" /> 手机端
              </span>
            </el-popover> -->
            <span @click="handleToPaas" v-if="clientToken">跳转到后台</span>
            <span @click="logout" v-if="clientToken">退出登录</span>
          </div>
        </div>
      </div>
      <div class="logo w-full">
        <img
          src="../../assets/img/logo.jpg"
          class="icon"
          alt=""
          @click="navTo('/mall')"
        />
        <div class="right">
          <div class="input">
            <el-input
              type="text"
              v-model="searchText"
              @keyup.enter.native="searchConfirm"
            />
            <div class="search" @click="searchConfirm()">
              <img src="../../assets/img/home/sou.svg" alt="" />
            </div>
          </div>

          <button @click="navTo('/mall/cart')">
            <img src="../../assets/img/home/gwc2.svg" alt="" />
            购物车
            <el-badge
              :value="cartNum"
              :max="99"
              class="item"
              style="margin-left: 5px"
            ></el-badge>
          </button>
          <button @click="navTo('/mall/regularPurchaseList')">
            <img src="../../assets/img/cgqd.png" alt="" />
            常购清单
          </button>
        </div>
      </div>
      <div
        class="typeList w-full"
        v-if="!['Cart', 'RegularPurchaseList'].includes(route)"
      >
        <Category :hierarchyList="hierarchyList" />
        <ul>
          <li
            v-for="item in typeList"
            :key="'type' + item.id"
            :class="{ selected: judgeCurPath(item.id) }"
            @click="selectType(item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div>杭州科普特电子有限公司</div>
      </div>
    </header>
    <div
      class="content"
      :style="{
        background: [
          'Cart',
          'GoodsDetail',
          'CreateOrder',
          'OrderDetail',
          'RegularPurchaseList'
        ].includes(route)
          ? '#fff'
          : '#f4f4f4'
      }"
    >
      <div class="container" :style="{ minHeight: clientHeight + 'px' }">
        <router-view :key="key"></router-view>
      </div>
    </div>
    <footer>
      <div class="container">
        <ul class="footerTop">
          <li>
            <img src="../../assets/img/home/zheng.png" alt="" />
            <span>正品行货资质齐全</span>
          </li>
          <li>
            <img src="../../assets/img/home/tui.png" alt="" />
            <span>15天无理由退货</span>
          </li>
          <li>
            <img src="../../assets/img/home/wei.png" alt="" />
            <span>预约维护服务</span>
          </li>
          <li>
            <img src="../../assets/img/home/you.png" alt="" />
            <span>0元包邮</span>
          </li>
          <li>
            <img src="../../assets/img/home/song.png" alt="" />
            <span>全国均可配送</span>
          </li>
        </ul>
        <div class="footerBottom">
          <!-- <ul>
            <li>关于我们</li>
            <li>帮助中心</li>
            <li>售后服务</li>
            <li>配送与验收</li>
            <li>商务合作</li>
            <li>企业采购</li>
            <li>开放平台</li>
            <li>搜索推荐</li>
            <li>友情链接</li>
          </ul> -->
          <p>
            Copyright © 2004 All Rights Reserved. 版权所有 备案号：
            <a href="https://beian.miit.gov.cn" target="_blank">
              浙ICP备2024060952号-1
            </a>
          </p>
          <p>
            服务电话 <span>4008165908</span> 投诉电话 <span>13758224489</span>
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import NoticeList from "../../components/NoticeList";
import {
  getClientSize,
  backToTop,
  otherSystemGetLoginToMeUrl,
} from "@/util/util";
import TipsInput from "../../components/TipsInput";
import Category from "@/components/Category";
import { online } from "@/api/platform";
export default {
  name: "Mall",
  computed: {
    ...mapState(["clientToken", "clientName"]),
    route () {
      return this.$route.name;
    },
    curPath () {
      return this.$route.path;
    },
    cartNum () {
      return this.$store.state.cartNum;
    },
  },
  components: {
    NoticeList,
    TipsInput,
    Category,
  },
  data () {
    return {
      clientHeight: getClientSize().height,
      shouldShowBT: false,
      searchText: "",
      typeList: [
        { id: -1, name: "首页" },
        { id: 1, name: "全部商品" },
      ],
      hierarchyList: [],
      key: '',
    };
  },
  mounted () {
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
    }
    if (this.clientToken) {
      this.getHierarchyList();
      this.$store.dispatch("getCartQuantity");
    } else {
      this.$store.commit("setData", {
        cartNum: 0,
      });
    }
  },
  methods: {
    ...mapMutations({
      clientLogout: "CLIENT_LOGOUT",
    }),
    // 生成二维码
    async getHierarchyList () {
      const { result } = await online({
        form_head_uuid: "850556846c4643ebbd8c24741481c3e0",
      });
      console.log('result', result);

      this.hierarchyList = result;
    },
    judgeCurPath (typeId) {
      if (typeId === -1) {
        if (this.curPath.indexOf("/show/index") > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.curPath.indexOf(`/show/goodsList/${typeId}`) > -1) {
          return true;
        } else {
          return false;
        }
      }
    },
    navTo (route) {
      this.$router.push(route);
    },
    logout () {
      localStorage.clear()
      this.navTo("/login");
    },
    backToTop () {
      backToTop();
    },
    searchTip (tip) {
      alert(tip);
    },
    searchConfirm () {
      if (this.searchText) {
        if (this.$route.query.searchText === this.searchText) {
          this.key = Math.random()
        } else {
          this.navTo(`/mall/show/goodsList/0/1?searchText=${this.searchText}`);
        }
      } else {
        this.navTo(`/mall/show/goodsList/1/all`);
      }
    },
    selectType (typeId) {
      //首页
      if (typeId === -1) {
        this.navTo("/mall/show/index");
      } else {
        this.navTo("/mall/show/goodsList/" + typeId + "/all");
      }
    },
    handleToPaas () {
      otherSystemGetLoginToMeUrl(
        "a29fd212e51c11eeb53b0242ac150003",
        "dCOsnTCUsE2p5xVI"
      );
    },
  },
  beforeDestroyed () { },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.w-full {
  width: 1200px;
  margin: 0 auto;
}
.Mall {
  width: 100%;
  // background: #f4f4f4;
  header {
    width: 100%;
    background: #fff;
    .header {
      height: 32px;
      background: #efefef;
      .w-full {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left,
        .right {
          .signIn {
            color: @thirdColor;
          }
          display: flex;
          span {
            padding: 0 10px;
            font-size: 12px;
            color: #888;
            cursor: pointer;
            border-right: 2px solid #ccc;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            img {
              margin-right: 5px;
            }
            &:last-child {
              border: 0;
            }
            &:hover {
              color: @thirdColor;
            }
          }
        }
      }
    }
    .logo {
      padding: 25px 10px;
      display: flex;
      justify-content: flex-start;
      .icon {
        height: 60px;
      }
      .right {
        margin-left: 100px;
        display: flex;
        .input {
          display: flex;
          justify-content: flex-start;
          .el-input {
            width: 500px;
            height: 36px;
          }
          /deep/.el-input__inner {
            width: 500px;
            height: 36px;
            background: #ffffff;
            border: 2px solid @thirdColor;
            padding: 0 15px;
            border-radius: 0;
          }
          .search {
            width: 58px;
            height: 36px;
            background: @thirdColor;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 20px;
            }
          }
        }
        button {
          width: 130px;
          height: 36px;
          border: 1px solid #e6e6e6;
          background: #fff;
          margin-left: 20px;
          font-size: 14px;
          color: #333333;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 20px;
            margin-right: 5px;
          }
          span {
            width: 18px;
            height: 18px;
            background: @thirdColor;
            border-radius: 9px;
            line-height: 18px;
            color: #fff;
            margin-left: 5px;
          }
        }
      }
    }
    .typeList {
      display: flex;
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 16px;
      color: #333;
      .sort {
        width: 200px;
        height: 40px;
        background: @thirdColor;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        margin-right: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          margin-right: 5px;
          width: 18px;
        }
      }
      ul {
        flex: 1;
        display: flex;
        justify-content: flex-start;
      }
      li {
        margin-right: 40px;
        cursor: pointer;
      }
      .selected {
        color: @thirdColor;
        font-weight: 500;
      }
      // .corporation{
      //   color: #f24f18;
      // }
    }
    .container {
      position: relative;
      // height: 100px;
      .title {
        position: absolute;
        left: 0;
        display: inline-block;
        height: 26px;
        top: 50%;
        margin-top: -13px;
        line-height: 26px;
        font-size: 28px;
        cursor: pointer;
        display: flex;
        align-items: center;
        img {
          width: 70px;
          background: #fff;
          margin-right: 20px;
        }
      }
      .NoticeListBox {
        position: absolute;
        left: 200px;
      }
      .right {
        position: absolute;
        right: 0;
        display: inline-block;
        height: 26px;
        top: 50%;
        margin-top: -13px;
        line-height: 26px;
        font-size: 14px;
        display: flex;
        align-items: center;
        span {
          margin-left: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
        }
        svg {
          width: 20px;
          height: 15px;
          cursor: pointer;
          margin-right: 2px;
        }
        .name {
          cursor: default;
        }
        .searchBox {
          // height: 36px;
          background: #fff;
          border-radius: 4px;
          padding-right: 10px;
          margin-right: 40px;
          i {
            color: #bfcbd9;
          }
        }
      }
    }
  }
  .content {
    // padding-top: 102px;
    padding-bottom: 30px;
  }
  .fixedAd {
    position: fixed;
    right: 0;
    top: 108px;
    width: 72px;
    img {
      display: block;
      width: 100%;
      height: 154px;
    }
    .fixedList {
      margin-top: 2px;
      background-color: white;
      width: 100%;
      li {
        width: 100%;
        height: 80px;
        text-align: center;
        border-bottom: 1px solid @borderColor;
        cursor: pointer;
        padding-top: 12px;
        i {
          display: block;
          font-size: 30px;
          color: #666666;
        }
        span {
          display: block;
          font-size: 14px;
          color: #666666;
          margin-top: 4px;
        }
        &:last-child {
          border-bottom: none;
        }
        &:hover {
          i {
            color: @thirdColor;
          }
          span {
            color: @thirdColor;
          }
        }
      }
    }
  }
  .bottomInfo {
    width: 100%;
    // height: 300px;
    border-top: 1px solid @borderColor;
    overflow: hidden;
    margin-top: 80px;
    .footerItem {
      width: 33%;
      height: 210px;
      position: relative;
      top: 45px;
      display: inline-block;
      text-align: center;
      vertical-align: middle;
      color: @fontDefaultColor;
      .title {
        color: @fontDeepColor;
        margin-bottom: 30px;
      }
    }
    .service {
      border-right: 1px solid @borderColor;
      span {
        display: inline-block;
        width: 80px;
        height: 100px;
        border: 1px solid @borderColor;
        text-align: center;
        margin: 0 10px;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: @thirdColor;
        }
        i {
          display: block;
          font-size: 30px;
          margin-top: 20px;
          margin-bottom: 10px;
        }
      }
    }
    .intro {
      border-right: 1px solid @borderColor;
      .intro-p {
        font-size: 13px;
        width: 300px;
        margin: 0 auto;
        text-align: left;
        color: @fontDeepColor;
        line-height: 1.8em;
      }
      div {
        text-align: left;
        font-size: 14px;
        margin-left: 47px;
        margin-top: 20px;
        img {
          margin: 0 6px;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
    .code {
      img {
        display: block;
        margin: 0 auto;
      }
      span {
        font-size: 12px;
        color: @thirdColor;
        margin-top: 10px;
        display: block;
      }
    }
  }
  footer {
    width: 100%;
    // height: 208px;
    padding-bottom: 30px;
    background-color: #414141;
    color: white;
    overflow: hidden;
    .footerTop {
      border-bottom: 1px solid #525252;
      display: flex;
      justify-content: space-between;
      padding: 50px 0;
      li {
        text-align: center;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span {
          font-size: 18px;
          margin-left: 12px;
        }
      }
    }
    .footerBottom {
      color: @fontDefaultColor;
      margin-top: 30px;
      font-size: 13px;
      text-align: center;
      ul {
        li {
          display: inline-block;
          cursor: pointer;
          padding: 0 6px;
          border-right: 2px solid @fontDefaultColor;
          &:last-child {
            border-right: none;
          }
        }
      }
      p {
        a {
          color: @fontDefaultColor;
          font-size: 13px;
        }
        margin-top: 5px;
        span {
          &:hover {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/Mall.vue